// material-ui
import { useMediaQuery, Container, Link, Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION ||============================== //

const AuthFooter = () => {
  const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
const year = new Date().getFullYear();

  return (
    <Container maxWidth="xl">
      <Stack
        direction={matchDownSM ? 'column' : 'row'}
        justifyContent={matchDownSM ? 'center' : 'space-between'}
        spacing={2}
        textAlign={matchDownSM ? 'center' : 'inherit'}
      >
        <Typography variant="subtitle2" color="secondary" component="span">
         Copyright © {year} www.kitcontact.in. All rights reserved. Designed &amp; Maintained by <Typography component={Link} variant="subtitle2" href="https://sterlingsys.in" target="_blank" underline="hover">
          Sterling Systems Pvt. Ltd

          </Typography>.

        </Typography>

        <Stack direction={matchDownSM ? 'column' : 'row'} spacing={matchDownSM ? 1 : 3} textAlign={matchDownSM ? 'center' : 'inherit'}>
          <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="/privacy-policy"
            target="_blank"
            underline="hover"
          >
            Privacy Policy
          </Typography>
          <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="/terms-and-conditions"
            target="_blank"
            underline="hover"
          >
            Terms And Conditions
          </Typography>
          <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="/data-collection-policy"
            target="_blank"
            underline="hover"
          >
            Data Collection Policy
          </Typography>
          <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="/data-retention-policy"
            target="_blank"
            underline="hover"
          >
            Data Retention Policy
          </Typography>
          {/* <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="/support"
            target="_blank"
            underline="hover"
          >
            Support
          </Typography> */}
        </Stack>
      </Stack>
    </Container>
  );
};

export default AuthFooter;
